import React from 'react';
import { stripHtml } from '../../shared/stripHtml';
import './ArticleSourcesList.scss';
import { useLayoutContext } from '../../providers/LayoutProvider';

export const ArticleSourcesList = ({ node, forceInline }) => {
    const { setInlineAnchor } = useLayoutContext();

    return (
        <section
            className={`article-sources ${
                forceInline ? `ws inline` : `kite-container`
            }`}
        >
            <h3>{node.field_heading}</h3>
            <ol>
                {node.field_sources?.map((src, idx) => {
                    return (
                        <li
                            id={`article-sources-${idx + 1}`}
                            key={`article-sources-${idx + 1}`}
                        >
                            <button
                                id={`sourceLink-${idx + 1}`}
                                onClick={() =>
                                    setInlineAnchor(
                                        `article-sources-${idx + 1}`
                                    )
                                }
                                type="button"
                            >
                                <span>({idx + 1})</span>
                                {stripHtml(src.value)}
                            </button>
                        </li>
                    );
                })}
            </ol>
        </section>
    );
};
